var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchCustomerNextOrders, fetchCustomerOrders, subscribeToOrder, fetchCustomerPendingOrders } from "../firebase-helpers/customerOrders";
import { OrderStatus } from "@tiffin/core";
// Define the initial state
var initialState = {
    status: "unknown",
    hasMoreOrders: true,
    orders: [],
};
export var getOrders = createAsyncThunk("orders/getCustomerOrders", function (payload, _a) {
    var dispatch = _a.dispatch;
    return __awaiter(void 0, void 0, void 0, function () {
        var pendingOrders, orders;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, fetchCustomerPendingOrders(payload.partnerId)];
                case 1:
                    pendingOrders = (_b.sent());
                    return [4 /*yield*/, fetchCustomerOrders(payload.partnerId)];
                case 2:
                    orders = (_b.sent());
                    processOrders(pendingOrders, function (order) { return dispatch(updateSubscribedOrder(order)); }, {
                        addSubscription: payload.addSubscription,
                        removeSubscription: payload.removeSubscription
                    });
                    return [2 /*return*/, __spreadArray(__spreadArray([], pendingOrders, true), orders, true)];
            }
        });
    });
});
export var getNextOrders = createAsyncThunk("orders/getNextCustomerOrders", function (payload, _a) {
    var getState = _a.getState;
    return __awaiter(void 0, void 0, void 0, function () {
        var state;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    state = getState();
                    return [4 /*yield*/, fetchCustomerNextOrders(state.customerOrders.orders[state.customerOrders.orders.length - 1].id, payload.partnerId)];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    });
});
var processOrders = function (orders, update, callbacks) {
    var _loop_1 = function (order) {
        if (order.status < OrderStatus.Completed) {
            var unsubcribe = subscribeToOrder(order.id, function (updatedOrder) {
                update(updatedOrder);
                if (updatedOrder.status >= OrderStatus.Completed) {
                    callbacks.removeSubscription(order.id);
                }
            });
            callbacks.addSubscription(order.id, unsubcribe);
        }
    };
    for (var _i = 0, orders_1 = orders; _i < orders_1.length; _i++) {
        var order = orders_1[_i];
        _loop_1(order);
    }
};
export var customerOrdersSlice = createSlice({
    name: "orders",
    initialState: initialState,
    reducers: {
        updateSubscribedOrder: function (state, action) {
            var foundIndex = state.orders.findIndex(function (x) { return x.id == action.payload.id; });
            state.orders[foundIndex] = action.payload;
        },
        updateReviewedOrder: function (state, action) {
            var foundIndex = state.orders.findIndex(function (order) { return order.id == action.payload; });
            state.orders[foundIndex].customerReview = true;
        }
    },
    extraReducers: function (builder) {
        builder.addCase(getOrders.pending, function (state) {
            state.status = "updating";
        });
        builder.addCase(getOrders.fulfilled, function (state, action) {
            state.status = "idle";
            state.orders = action.payload;
        });
        builder.addCase(getOrders.rejected, function (state, action) {
            state.status = "failed";
            state.error = action.error.message;
        });
        builder.addCase(getNextOrders.pending, function (state) {
            state.status = "updating";
        });
        builder.addCase(getNextOrders.fulfilled, function (state, action) {
            state.status = "idle";
            if (action.payload.length > 0) {
                state.orders = __spreadArray(__spreadArray([], state.orders, true), action.payload, true);
            }
            else {
                state.hasMoreOrders = false;
            }
        });
        builder.addCase(getNextOrders.rejected, function (state, action) {
            state.status = "failed";
            state.error = action.error.message;
        });
    }
});
export var updateSubscribedOrder = (_a = customerOrdersSlice.actions, _a.updateSubscribedOrder), updateReviewedOrder = _a.updateReviewedOrder;
export default customerOrdersSlice.reducer;
